import {ApiClient} from '@hconnect/apiclient'
import {QueryKey} from '@hconnect/common/hooks'
import {useMutation, useQueryClient} from '@tanstack/react-query'
import type {UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {KpiUpdate} from '../types'

const mutationKey = 'expert-system-hierarchy-kpis-update'

export const useUpdateKpiHierarchy = (
  options?: UseMutationOptions<void, AxiosError<{message?: string}>, KpiUpdate>
) => {
  const queryClient = useQueryClient()

  return useMutation<void, AxiosError<{message?: string}>, KpiUpdate>({
    mutationKey: [mutationKey],
    mutationFn: async (payload) => {
      const {plantId, equipmentType, ...body} = payload
      const response = await ApiClient.axiosInstance.put(
        `/expert-system/kpis/hierarchy/${plantId}/${equipmentType}`,
        body
      )
      return response.data
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({queryKey: [QueryKey]})
      options?.onSuccess?.(...args)
    }
  })
}
